/* istanbul ignore file */
import React from 'react';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import { CREATE_JOURNAL_ENTRY } from 'domain/finance/journalEntry/useJournalEntryService';
import { EditButton } from 'framework/ui/ui-builder';

const EditJournalEntryButton = () => {
  const { getUpdateEntityUrl } = useJournalEntryUrl();

  return (
    <EditButton
      path={getUpdateEntityUrl}
      label="Edit"
      key="edit-journal-entry"
      permissionToCheck={CREATE_JOURNAL_ENTRY}
      outline
    />
  );
};

export default EditJournalEntryButton;
